module.exports = {
	"data": {
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"fields": {
							"slug": "/mongo-db-vs-dynamo-db"
						},
						"excerpt": "MongoDB is an open-source document database first released in 2009. It was enormously influential in kicking off the NoSQL revolution due to...",
						"timeToRead": 7,
						"frontmatter": {
							"title": "MongoDB vs. DynamoDB",
							"date": "2/27/2020"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/leaderboard-write-sharding"
						},
						"excerpt": "In this example, we'll show how to maintain a  global leaderboard  with a dataset in DynamoDB. A leaderboard is a common need for data...",
						"timeToRead": 9,
						"frontmatter": {
							"title": "Leaderboard & Write Sharding",
							"date": "12/26/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/updating-deleting-items"
						},
						"excerpt": "In this lesson, we'll learn about updating and deleting Items. This is the final lesson on Single-Item Actions. The next chapter is on Multi...",
						"timeToRead": 5,
						"frontmatter": {
							"title": "Updating & Deleting Items",
							"date": "12/17/2017"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/expression-basics"
						},
						"excerpt": "In this lesson, we will cover using expressions with DynamoDB. Expressions are an integral part of using DynamoDB, and they are used in a...",
						"timeToRead": 7,
						"frontmatter": {
							"title": "Expression Basics",
							"date": "12/17/2017"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/additional-reading"
						},
						"excerpt": "Articles: SQL, NoSQL, and Scale: How DynamoDB scales where relational databases don't  - This is a post of mine explaining the core...",
						"timeToRead": 3,
						"frontmatter": {
							"title": "Additional Reading",
							"date": "1/5/2020"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
						},
						"excerpt": "Secondary indexes are a critical part of modeling your data in DynamoDB. With a secondary index, you can add additional access patterns to...",
						"timeToRead": 8,
						"frontmatter": {
							"title": "Local or global: Choosing a secondary index type in DynamoDB",
							"date": "1/16/2020"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/working-with-multiple-items"
						},
						"excerpt": "In the previous chapter, we worked with a single Item at a time -- inserting, retrieving, updating, and deleting. In this chapter, we're...",
						"timeToRead": 8,
						"frontmatter": {
							"title": "Working with Multiple Items",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/filtering"
						},
						"excerpt": "In previous sections, we've covered key expressions, condition expressions, projection expressions, and update expressions. This lesson...",
						"timeToRead": 3,
						"frontmatter": {
							"title": "Filtering",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/scans"
						},
						"excerpt": "In this lesson, we'll talk about using Scans with DynamoDB. The Scan call is the bluntest instrument in the DynamoDB toolset. By way of...",
						"timeToRead": 4,
						"frontmatter": {
							"title": "Scans",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/querying"
						},
						"excerpt": "Querying is a very powerful operation in DynamoDB. It allows you to select multiple Items that have the same partition (\"HASH\") key but...",
						"timeToRead": 6,
						"frontmatter": {
							"title": "Querying",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/anatomy-of-an-item"
						},
						"excerpt": "An  item  is the core unit of data in DynamoDB. It is comparable to a row in a relational database, a document in MongoDB, or a simple...",
						"timeToRead": 8,
						"frontmatter": {
							"title": "Anatomy of an Item",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/inserting-retrieving-items"
						},
						"excerpt": "Items  are the key building block in DynamoDB. In this lesson, we're going to learn the basics of inserting and retrieving items with...",
						"timeToRead": 6,
						"frontmatter": {
							"title": "Inserting & Retrieving Items",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/what-is-dynamo-db"
						},
						"excerpt": "DynamoDB  is a hosted NoSQL database offered by Amazon Web Services (AWS). It offers: reliable performance  even as it scales; a  managed...",
						"timeToRead": 2,
						"frontmatter": {
							"title": "What is DynamoDB?",
							"date": "1/1/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/secondary-indexes"
						},
						"excerpt": "Up to this point, most read operations have used a table's primary key directly, either through the  GetItem  call or the  Query  call...",
						"timeToRead": 3,
						"frontmatter": {
							"title": "Secondary Indexes",
							"date": "03/20/2019"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/hierarchical-data"
						},
						"excerpt": "In this example, we'll show how to model hierarchical data using DynamoDB. We'll insert a real dataset of 25,000 Starbucks locations into...",
						"timeToRead": 10,
						"frontmatter": {
							"title": "Hierarchical Data",
							"date": "01/06/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/dynamodb-streams"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "DynamoDB Streams",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/global-secondary-indexes"
						},
						"excerpt": "In this example, we'll learn about  global secondary indexes . Just like the last lesson, we'll cover the basics first before diving into an...",
						"timeToRead": 5,
						"frontmatter": {
							"title": "Global Secondary Indexes",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/local-secondary-indexes"
						},
						"excerpt": "In the  previous lesson , we learned some basics about secondary indexes. In this lesson, we'll dive deeper into local secondary indexes...",
						"timeToRead": 5,
						"frontmatter": {
							"title": "Local Secondary Indexes",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/data-modeling-overview"
						},
						"excerpt": "This chapter includes a number of case studies, each exploring a way to model data in DynamoDB for a particular scenario. Sometimes, seeing...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Overview",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/backups-restores"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Backups & Restores",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/autoscaling"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Autoscaling",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/provisioning-tables"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Provisioning tables",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/global-tables"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Global Tables",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/security"
						},
						"excerpt": "Coming soon!",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Security",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/environment-setup"
						},
						"excerpt": "In many of the subsequent lessons, we'll be directly interacting with the AWS DynamoDB APIs. To do this, we'll need to set up our...",
						"timeToRead": 2,
						"frontmatter": {
							"title": "Environment Setup",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/the-dynamo-paper"
						},
						"excerpt": "In 2004, Amazon.com was growing rapidly and was starting to hit the upper scaling limits of its Oracle database. It started to consider...",
						"timeToRead": 7,
						"frontmatter": {
							"title": "The Dynamo Paper",
							"date": "01/01/2018"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/key-concepts"
						},
						"excerpt": "In this section, we'll cover the key concepts you need to know about DynamoDB. At the end of this section, you will understand: tables...",
						"timeToRead": 4,
						"frontmatter": {
							"title": "Key Concepts",
							"date": "01/01/2018"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/index.json
// module chunks = 9347362237655822000